import { createLocaleMessages } from "./createLocaleMessages";

export const IT_TRANSLATIONS = createLocaleMessages({
  common: {
    appName: "Screen0",
    loading: "Caricamento…",
    loadingSettings: "Caricamento impostazioni",
    loadingInsight: "Caricamento insight…",
    close: "Chiudi",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    done: "Fine",
    send: "Invia",
    add: "Aggiungi",
    create: "Crea",
    edit: "Modifica",
    available: "Disponibile",
    unavailable: "Non disponibile",
    checking: "verifica in corso",
    somethingWentWrong: "Qualcosa è andato storto",
    today: "Oggi",
    thisWeek: "Questa settimana",
    thisMonth: "Questo mese",
    backToToday: "Torna a Oggi",
    openSettings: "Apri impostazioni",
    primaryNavLabel: "Principale",
    noUsage: "Nessun utilizzo",
    emDash: "—",
    thinking: "Sto pensando...",
    opening: "Apertura…",
    ok: "OK",
    dismiss: "Ignora",
    unknown: "Sconosciuto",
  },
  navigation: {
    today: "Oggi",
    habits: "Abitudini",
    insight: "Insight",
    rules: "Regole",
    settings: "Impostazioni",
    premiumLocked: "Premium",
  },
  today: {
    titleToday: "Oggi",
    titleThisWeek: "Questa settimana",
    titleThisMonth: "Questo mese",
    periodDay: "Giorno",
    periodWeek: "Settimana",
    periodMonth: "Mese",
    periodLabel: "Periodo",
    viewApps: "App",
    viewCategories: "Categorie",
    metricScreenTime: "Tempo di utilizzo",
    metricScreenTimeAndroid: "Tempo di utilizzo",
    metricActivations: "Attivazioni",
    viewToggleAria: "Vista: {view}. Tocca per cambiare.",
    metricToggleAria: "Metrica: {metric}. Tocca per cambiare.",
    periodToggleAria: "Periodo: {period}. Tocca per cambiare.",
    prevNavAria: "{period} precedente",
    nextNavAria: "{period} successivo",
    navDay: "giorno",
    navWeek: "settimana",
    navMonth: "mese",
    noSnapshotDayTitle: "Nessuno snapshot per questo giorno",
    noSnapshotWeekTitle: "Nessuno snapshot per questa settimana",
    noSnapshotMonthTitle: "Nessuno snapshot per questo mese",
    noSnapshotDayBody:
      "Non è stato salvato alcuno snapshot per questo giorno. Prova un'altra data o torna a oggi.",
    noSnapshotWeekBody:
      "Questa settimana non ha ancora abbastanza snapshot salvati. Prova una settimana precedente o controlla dopo altre acquisizioni giornaliere.",
    noSnapshotMonthBody:
      "Questo mese non ha ancora abbastanza snapshot salvati. Prova un mese precedente o controlla dopo altre acquisizioni giornaliere.",
    preInstallDayTitle: "Nessun dato per questo giorno",
    preInstallDayBody:
      "I dati di utilizzo sono disponibili solo da quando hai installato Screen0 su questo dispositivo. Le date precedenti non sono disponibili.",
    preInstallWeekTitle: "Nessun dato per questa settimana",
    preInstallWeekBody:
      "L'intera settimana è anteriore all'installazione di Screen0 su questo dispositivo, quindi non ci sono dati di utilizzo.",
    preInstallMonthTitle: "Nessun dato per questo mese",
    preInstallMonthBody:
      "L'intero mese è anteriore all'installazione di Screen0 su questo dispositivo, quindi non ci sono dati di utilizzo.",
    noUsageRecorded: "Nessun utilizzo registrato",
    permissionNeededTitle: "Autorizzazione necessaria per il report di oggi",
    permissionNeededBody:
      "Screen0 funziona senza account, ma iOS richiede l'autorizzazione Tempo di utilizzo prima di mostrare l'uso delle app.",
    permissionNeededBodyAndroid:
      "Screen0 ha bisogno dell'accesso ai dati di utilizzo per mostrare le app di oggi. Tocca sotto per aprire le Impostazioni di sistema, trova Screen0 e attiva l'accesso ai dati di utilizzo. Android non mostra una finestra di autorizzazione per questo permesso.",
    permissionNeededBodyAndroidRestricted:
      "Android ha bloccato questa autorizzazione perché Screen0 è stato installato fuori da uno store. Tocca prima «Apri info app di Screen0» qui sotto, apri il menu ⋮ in alto a destra e scegli «Consenti impostazioni limitate» (conferma con il PIN). Poi torna qui e attiva l'accesso ai dati di utilizzo.",
    openAppInfo: "Apri info app di Screen0",
    permissionDeniedHint:
      "Apri Impostazioni e tocca Richiedi accesso a Tempo di utilizzo, poi approva la finestra di Apple «Utilizzo app e siti web» per sbloccare il report di oggi.",
    openUsageAccess: "Apri accesso ai dati di utilizzo",
    reasonIosDataExportRequires264:
      "Apple consente alle app di leggere i dati Tempo di utilizzo solo da iOS 26.4 o versioni successive. Aggiorna iOS per vedere l'utilizzo qui.",
    reasonDataExportUnavailable:
      "Apple consente attualmente l'esportazione dei dati Tempo di utilizzo solo su dispositivi nell'UE, quindi su questo dispositivo non è possibile leggere alcun utilizzo.",
    reasonExtensionSnapshotMissing:
      "L'estensione del report è partita, ma lo snapshot del gruppo app non era leggibile in questa esecuzione.",
    reasonReportViewNotMounted:
      "Screen0 non è riuscito a montare l'host nativo del report Attività dispositivo.",
    reasonDefaultNoData:
      "Usa il telefono per qualche minuto, poi torna a Oggi o riapri Screen0. iOS può anche non restituire dati all'inizio della giornata.",
    reasonDefaultNoDataAndroid:
      "L'accesso ai dati di utilizzo è attivo. Usa il dispositivo per qualche minuto, poi torna a Oggi o riapri Screen0 — Android può impiegare un po' a fornire i primi dati.",
    collectingUsageTitle: "Lettura dei dati di utilizzo…",
    collectingUsageBody:
      "L'accesso ai dati di utilizzo è attivo. Screen0 sta leggendo l'utilizzo di oggi — ci vuole solo un istante.",
    collectingUsageBodyAndroid:
      "L'accesso ai dati di utilizzo è attivo. Screen0 sta leggendo l'utilizzo di oggi da Android — subito dopo la concessione può richiedere qualche secondo.",
    reasonUsageEventsUnavailableAndroid:
      "L'accesso ai dati di utilizzo risulta attivo, ma Android non sta ancora condividendo i dati con Screen0. Apri le Impostazioni, disattiva e riattiva l'accesso ai dati di utilizzo per Screen0, poi riapri l'app. Se l'app è stata installata fuori da uno store, scegli prima «Consenti impostazioni limitate» da Info app (menu ⋮).",
    reasonAppsNotVisibleAndroid:
      "Android ha registrato dell'utilizzo, ma Screen0 non è riuscito a identificare le app. Aggiorna o reinstalla Screen0 e riprova.",
    weeklyActivationsNotTracked: "Le attivazioni settimanali non sono ancora tracciate",
    monthlyActivationsNotTracked: "Le attivazioni mensili non sono ancora tracciate",
    activationsNotTracked: "Attivazioni non ancora tracciate",
    topApps: "App principali",
    allApps: "Tutte le app",
    topCategories: "Categorie principali",
    allCategories: "Tutte le categorie",
    topActivations: "Attivazioni principali",
    allActivations: "Tutte le attivazioni",
    topCategoryActivations: "Attivazioni per categoria principali",
    allCategoryActivations: "Tutte le attivazioni per categoria",
    viewAllAppsAria: "Vedi tutte le app",
    viewAllCategoriesAria: "Vedi tutte le categorie",
    viewAllActivationsAria: "Vedi tutte le attivazioni",
    viewAllCategoryActivationsAria: "Vedi tutte le attivazioni per categoria",
    dayShape: "Andamento del giorno",
    weekShape: "Andamento della settimana",
    monthShape: "Andamento del mese",
    dailyAverage: "Media giorn.",
    dailyAverageOn: "attiva",
    dailyAverageOff: "disattiva",
    dailyAverageToggleAria: "Media giornaliera {state}. Tocca per attivare o disattivare.",
  },
  habits: {
    title: "Abitudini",
    timeframe: "Ultimi 12 mesi",
    reorder: "Riordina app",
    doneReordering: "Riordino completato",
    openFilter: "Apri filtro abitudini",
    metricToggleAria: "Metrica: {metric}. Tocca per cambiare.",
    emptyTitle: "Nessun dato sull'utilizzo delle app",
    emptyBody:
      "Consenti l'accesso a Tempo di utilizzo da Oggi per tracciare le tue abitudini.",
    emptyBodyAndroid:
      "Consenti l'accesso ai dati di utilizzo da Oggi per tracciare le tue abitudini.",
    filterView: "Vista",
    filterTrackApps: "Traccia app",
    filterTrackCategories: "Traccia categorie",
    filterCategories: "Categorie",
    filterShowingAll: "Mostra tutto. Seleziona per tracciare solo elementi specifici.",
    filterTrackingSelected: "Tracciamento di {count} selezionati.",
    filterSearchPlaceholder: "Cerca app che hai usato",
    filterSearchAria: "Cerca app",
    closeFilter: "Chiudi filtro",
    previousMonth: "Mese precedente",
    nextMonth: "Mese successivo",
    filterOtherSection: "Bucket Altro",
    includeOther: "Includi Altro",
    includeOtherAria: "Includi il bucket Altro nelle abitudini",
    includeOtherInfoAria: "Cos'è il bucket Altro?",
    otherInfoTitle: "Cos'è Altro?",
    otherInfoBody:
      "Altro è il tempo di utilizzo che iOS non ha potuto assegnare a un'app specifica. Spesso proviene da app disinstallate, utilizzo di sistema o piccole differenze tra il Tempo di utilizzo totale e la somma delle singole app.",
    otherInfoBodyAndroid:
      "Altro è il tempo di utilizzo che Android non ha potuto assegnare a un'app specifica. Spesso proviene da app disinstallate, utilizzo di sistema o piccole differenze tra il totale e la somma delle singole app.",
  },
  insight: {
    title: "Insight",
    timeframe: "Ultimi {days} giorni",
    compulsivity: "Compulsività",
    doomScrollRisk: "Doom-scroll",
    aboutMetricAria: "Informazioni su {metric}",
    compulsivityBody1:
      "Quanto spesso riapri le stesse app rispetto a tutto il resto sul telefono. Punteggi alti di solito indicano frequenti sblocchi e visite ripetute, non solo sessioni lunghe.",
    compulsivityBody2:
      "Screen0 combina quanto spesso un'app viene aperta, quanto tempo totale occupa e in quanti giorni compare negli snapshot recenti.",
    compulsivityBody3:
      "Sono stime proxy degli ultimi 14 giorni — pattern utili, non una misura clinica.",
    doomBody1:
      "App il cui utilizzo tende a ripetersi e concentrarsi in poche ore del giorno — il tipo di pattern che può sfociare in scrolling automatico, in qualsiasi momento.",
    doomBody2:
      "Screen0 valuta quanto tempo occupa un'app, quanto compare in modo costante e quanto è concentrato l'utilizzo durante la giornata negli snapshot recenti.",
    doomBody3:
      "I punteggi sono stime proxy degli ultimi 14 giorni e riflettono abitudini, non intenzioni.",
    activateSmartBlockAria: "Attiva Smart Block per {appName}",
    reactivateSmartBlockAria: "Riattiva Smart Block per {appName}",
    activeSmartBlocksTitle: "Smart Block attivi",
    activeSmartBlocksAria: "Regole Smart Block attive su questo dispositivo",
    goToActiveSmartBlockRuleAria: "Vai alla regola per {appName}",
    activateSmartBlockTitle: "Attivare questo Smart Block?",
    reactivateSmartBlockTitle: "Riattivare questo Smart Block?",
    activateConfirmBody:
      "Crea una regola attiva che sospende {appName} ogni giorno, {window}.",
    reactivateConfirmBody:
      "Riattiva la regola esistente per {appName} ogni giorno, {window}.",
    activate: "Attiva",
    reactivate: "Riattiva",
    notFoundTitle: "Insight non trovato",
    notFoundBody: "Questo insight potrebbe essere stato eliminato o non è ancora stato generato.",
    statusPermissionNeededBodyAndroid:
      "Consenti l'accesso ai dati di utilizzo da Oggi prima che Insight possa valutare i pattern delle app recenti.",
    openExclude: "Gestisci app escluse da Insight",
    excludeSheetTitle: "Escludi da Insight",
    closeExclude: "Chiudi esclusioni",
    excludeSectionLabel: "App escluse",
    excludeHelperAllIncluded:
      "Tutte le app sono incluse nei punteggi Insight. Seleziona le app da escludere da compulsività, doom-scroll e suggerimenti Smart Block.",
    excludeHelperCount: "{count} app escluse dai punteggi Insight.",
    excludeSearchPlaceholder: "Cerca app che hai usato",
    excludeSearchAria: "Cerca app",
    excludeSearchResults: "Risultati di ricerca",
    excludeSearching: "Ricerca…",
    excludeNoMatchingApps: "Nessuna app corrispondente",
    excludeNoApps: "Nessuna app in questo periodo",
    excludeIncludeAll: "Includi tutte",
    smartBlockPrePickerTitle: "Scegli le app in Tempo di utilizzo",
    smartBlockPrePickerReactivateTitle: "Seleziona di nuovo le app in Tempo di utilizzo",
    smartBlockPrePickerBody:
      "La schermata successiva è il selettore app di Apple. Scegli {appName} così Screen0 può bloccarla in questa finestra Smart Block.",
    smartBlockPrePickerReactivateBody:
      "La schermata successiva è il selettore app di Apple. Scegli di nuovo {appName} così Screen0 può applicare questo Smart Block.",
    smartBlockPrePickerNext: "Avanti",
    smartBlockPickerTitle: "Scegli {appName}",
    smartBlockPickerHeader: "Scegli {appName}",
    smartBlockPickerFooter:
      "Seleziona l'app suggerita dal tuo Smart Block. Screen0 non può verificare la scelta — seleziona con attenzione.",
    smartBlockHonorTitle: "Hai scelto {appName}?",
    smartBlockHonorBody:
      "Nella schermata precedente avresti dovuto selezionare l'app a cui punta questo Smart Block.",
    smartBlockHonorYes: "Sì, continua",
    smartBlockHonorNo: "No",
    smartBlockDeclinedTitle: "Lo Smart Block richiede {appName}",
    smartBlockDeclinedBody:
      "Questo Smart Block non può essere creato se non scegli {appName} nel selettore di Apple.",
    smartBlockRetryPicker: "Riprova",
    smartBlockNonConformingTitle: "La selezione non corrisponde allo Smart Block",
    smartBlockNonConformingBody:
      "Hai selezionato {appCount} app, {categoryCount} categorie e {siteCount} siti web. La regola può comunque essere creata, ma non sarà contrassegnata come Smart Block.",
    smartBlockNonConformingContinue: "Crea regola manuale",
  },
  rules: {
    title: "Regole",
    reorder: "Riordina",
    doneReordering: "Riordino completato",
    dismiss: "Ignora",
    activeRulesTitle: "Regole pianificate",
    activeRulesLoading: "Caricamento…",
    activeRulesEnforcing: "{count} in applicazione ora",
    activeRulesEmptySchedule: "Pianifica una sospensione",
    noActiveRulesTitle: "Nessuna regola pianificata",
    noActiveRulesBody:
      "Scegli cosa bloccare, quando e in quali giorni — la prima regola richiede circa un minuto.",
    newRule: "Nuova regola",
    targetsTitle: "Obiettivi",
    targetsSaved: "{count} salvati",
    targetsEmptySubtitle: "Gruppi di blocco riutilizzabili per app e siti",
    noTargetsTitle: "Nessun obiettivo",
    noTargetsBody:
      "Crea un gruppo con nome di app, siti o categorie — poi riutilizzalo in regole e sessioni rapide.",
    newTarget: "Nuovo obiettivo",
    addSectionAria: "Aggiungi {title}",
    deleteRuleAria: "Elimina regola",
    deleteTargetAria: "Elimina obiettivo",
    deleteRuleConfirmAria: "Eliminare questa regola?",
    deleteTargetConfirmAria: "Eliminare questo obiettivo?",
    deleteRuleConfirm: "Eliminare questa regola?",
    deleteTargetConfirm: "Eliminare questo obiettivo?",
    deleteRuleCoveredConfirm:
      "Eliminare questa regola? Le stesse app e siti restano bloccati da un'altra regola attiva.",
    deleteTargetCoveredConfirm:
      "Eliminare questo obiettivo? Le stesse app e siti restano bloccati da un'altra regola attiva.",
    deleteRuleCoveredConfirmAria: "Eliminare questa regola mantenendo il blocco?",
    deleteTargetCoveredConfirmAria: "Eliminare questo obiettivo mantenendo il blocco?",
    editRuleAria: "Modifica {name}",
    editTargetAria: "Modifica {targetName}",
    enableRuleAria: "Attiva regola",
    disableRuleAria: "Disattiva regola",
    noTargets: "Nessun obiettivo",
    ruleUpdated: "Regola aggiornata.",
    ruleCreated: "Regola creata.",
    ruleSaveFailed: "Impossibile salvare la regola. Riprova.",
    targetCreated: "Obiettivo creato.",
    targetUpdated: "Obiettivo aggiornato.",
    targetSaveFailed: "Impossibile salvare l'obiettivo. Riprova.",
    ruleDeleted: "Regola eliminata.",
    targetDeleted: "Obiettivo eliminato. Le regole che usavano solo questo obiettivo sono state rimosse.",
    editRule: "Modifica regola",
    newRuleEditor: "Nuova regola",
    saveRule: "Salva regola",
    createRule: "Crea regola",
    editTarget: "Modifica obiettivo",
    newTargetEditor: "Nuovo obiettivo",
    saveTarget: "Salva obiettivo",
    createTarget: "Crea obiettivo",
    targetsSection: "Obiettivi",
    targetsLimitHint: "Massimo {max} per regola",
    targetsLimitReached: "Puoi selezionare al massimo {max} obiettivi per regola. Deselezionane uno per aggiungerne un altro.",
    targetsRequired: "Seleziona almeno un obiettivo per salvare questa regola.",
    targetEditorFromRule: "Aggiungi un obiettivo per questa regola",
    targetEditorFromQuickStart: "Aggiungi un obiettivo per l'avvio rapido",
    backToRule: "Torna alla regola",
    backToQuickStart: "Torna all'avvio rapido",
    websiteCategoriesLink: "Sfoglia categorie siti",
    websiteCategoriesHint: "Blocca interi gruppi come Social o Notizie — senza digitare domini.",
    createTargetCta: "Crea il tuo primo obiettivo",
    createTargetHint: "Dai un nome a un gruppo di app o siti, poi sceglilo nelle regole.",
    daysSection: "Giorni",
    timeWindowSection: "Finestra oraria",
    startLabel: "Inizio",
    endLabel: "Fine",
    endsLabel: "Termina",
    durationMode: "Durata",
    endTimeMode: "Ora di fine",
    blockDurationAria: "Durata del blocco in minuti",
    targetNamePlaceholder: "es. Social, Distrazioni lavoro",
    chooseAppsSites: "Scegli app e siti da bloccare",
    websitePlaceholder: "esempio.com",
    websiteAria: "Dominio del sito web",
    tapToChangeBlocked: "Tocca per cambiare cosa bloccare",
    chosenOnDevice: "Scelto su questo iPhone",
    changeBlockedAppsAria: "Cambia app bloccate",
    viewFullBlockedListAria: "Vedi elenco completo bloccati",
    view: "Visualizza",
    smartBlockBadge: "Smart Block",
    smartBlockRuleWindowTitle: "Modifica orario Smart Block",
    smartBlockRuleWindowBody:
      "Puoi modificare solo quando è attivo questo Smart Block. App, giorni e altre impostazioni restano bloccate.",
    smartBlockRuleWindowAria: "Modifica fascia oraria Smart Block",
    smartBlockMinDurationError: "Gli Smart Block devono durare almeno 1 ora.",
    smartBlockEndBeforeStartError: "L'orario di fine deve essere dopo l'inizio.",
    smartBlockRuleNotEditable: "Non puoi modificare una regola Smart Block.",
    smartBlockTargetNotEditable: "Gli obiettivi Smart Block non possono essere modificati.",
    smartBlockRuleNotEditableAria: "Regola Smart Block non modificabile",
    smartBlockTargetNotEditableAria: "Obiettivo Smart Block non modificabile",
    enforcementBannerTitle: "In applicazione ora",
    enforcementBannerEndsIn: "Termina tra {time}",
    enforcementBannerMore: "+{count} altre",
    enforcementBreakBannerTitle: "Pausa attiva",
    enforcementBreakBannerEndsIn: "Termina tra {time}",
    quickStart: {
      fabLabel: "Avvia",
      fabAria: "Avvia una sessione di blocco rapida",
      drawerTitle: "Avvio rapido",
      durationLabel: "Durata",
      durationAria: "Durata della sessione rapida in minuti",
      recentTab: "Recenti",
      savedTab: "Salvate",
      savePrompt: "Dai un nome a questa sessione",
      savePromptTitle: "Salva nei preferiti",
      savePromptHint: "Tocca la stella su una sessione recente per riutilizzarla con un tap.",
      saveNamePlaceholder: "es. Ora di focus",
      noRecents: "Nessuna sessione recente",
      noSaved: "Nessuna sessione salvata",
      createTarget: "Nuovo obiettivo",
      changeIcon: "Cambia icona",
      sessionActive: "Blocco attivo",
      saveStarAria: "Salva sessione",
      savedStarAria: "Sessione salvata",
      defaultSessionName: "Sessione",
      startButton: "Avvia sessione",
      noValidTargets: "Quegli obiettivi sono stati rimossi. Seleziona almeno un obiettivo.",
    },
    swipeUnlock: {
      trackLabel: "Scorri per fermare il blocco",
      trackAria: "Trascina per fermare tutti i blocchi",
      overlayTitle: "Tieni premuto per sbloccare",
      overlayBody: "Questo ferma subito ogni regola e sessione attiva. Tieni premuto per confermare che vuoi davvero sbloccare.",
      holdAria: "Tieni premuto per confermare",
      holdHint: "Continua a tenere premuto…",
      takeBreak: "Fai una pausa di {minutes} minuti",
    },
    forcedSuspend: {
      badge: "In pausa",
      subtitle: "Tocca power per riattivare il blocco.",
      autoResume: "Riprende {time}.",
      resumeRuleAria: "Riprendi il blocco per questa regola",
    },
    vpnInstallPrompt: {
      title: "Installa il filtro per i siti",
      body: "Una regola sta bloccando siti in questo momento. Installa il profilo VPN sul dispositivo così restano bloccati in Safari.",
      bodyAndroid:
        "Una regola sta bloccando siti in questo momento. Installa il profilo VPN sul dispositivo così restano bloccati in Chrome e negli altri browser.",
      install: "INSTALLA PROFILO",
      installing: "INSTALLAZIONE…",
      notNow: "NON ORA",
      dismissAria: "Chiudi richiesta filtro siti",
    },
    vpnWebTargetGate: {
      title: "Filtro siti richiesto",
      body:
        "Per bloccare siti serve il profilo filtro sul dispositivo. Gli obiettivi solo app funzionano senza — installa il profilo per aggiungere domini o categorie.",
      banner:
        "Installa il filtro siti sul dispositivo per aggiungere domini o categorie qui.",
      install: "INSTALLA PROFILO",
      installing: "INSTALLAZIONE…",
      continueAppsOnly: "Solo app",
      dismissAria: "Chiudi richiesta filtro siti",
      saveBlocked: "Installa il filtro siti per salvare nuovi domini o categorie.",
    },
    appBlockingPermissionGate: {
      overlayBanner:
        "Per bloccare le app serve “Mostra sopra altre app”. Attivalo così può comparire la schermata di blocco.",
      overlayCta: "APRI IMPOSTAZIONI",
      usageBanner:
        "Per bloccare le app serve l’accesso all’utilizzo. Attivalo così Screen0 può vedere quale app è aperta.",
      usageCta: "APRI ACCESSO UTILIZZO",
      bannerAria: "Abilita il permesso necessario per il blocco app",
    },
  },
  chat: {
    title: "Chiedi a Screen0",
    engineIosLocal: "IA locale su iOS",
    engineAndroidLocal: "IA locale su Android",
    engineCloud: "IA cloud",
    closeChatAria: "Chiudi chat",
    suggestionWhatChanged: "Cosa è cambiato oggi?",
    suggestionWhichApp: "Quale app mi ha attirato?",
    suggestionTonight: "Cosa provare stasera?",
    placeholder: "Chiedi del tuo utilizzo",
    sendAria: "Invia",
    unableToAnswer: "Impossibile rispondere in questo momento.",
    localAiUnavailableSuffix:
      "L'IA locale non è disponibile al momento. La chat cloud non viene usata automaticamente su questo dispositivo.",
  },
  insightChat: {
    fabAria: "Chiedi del tuo utilizzo del telefono",
    title: "Chat sull'utilizzo",
    privacyBadge: "100% sul dispositivo",
    engineIosLocal: "IA locale su iOS",
    engineAndroidLocal: "IA locale su Android",
    greeting:
      "Cosa vorresti sapere su come usi il telefono? Posso spiegare i pattern della finestra Insight recente.",
    suggestionTotalUsage: "Quanto ho usato il telefono?",
    suggestionTopApp: "Quale app uso di più?",
    suggestionBusiestDays: "In quali giorni uso di più il telefono?",
    suggestionBusiestBands: "Quali fasce orarie sono più intense?",
    suggestionTopAppWhy: "Perché tendo a usare {appName} così tanto?",
    suggestionTopAppWhyGeneric: "Perché tendo a usare l'app che uso di più così tanto?",
    suggestionComparePeriods: "Confronta questo periodo con il precedente",
    placeholder: "Chiedi dei tuoi pattern di utilizzo",
    sendAria: "Invia messaggio",
    closeAria: "Chiudi chat sull'utilizzo",
    unableToAnswer: "Impossibile rispondere in questo momento.",
    contextLoading: "Preparo il contesto di utilizzo…",
    contextError: "Impossibile caricare il contesto di utilizzo. Riprova o chiudi e riapri la chat.",
    contextEmpty: "Non ci sono ancora abbastanza dati di utilizzo recenti per la chat.",
    retryContext: "Riprova",
  },
  settings: {
    title: "Impostazioni",
    controlsEyebrow: "Controlli",
    screenTimeSection: "Tempo di utilizzo",
    screenTimeSectionAndroid: "Accesso ai dati di utilizzo",
    permissionLabel: "Autorizzazione",
    requestingAccess: "Richiesta accesso in corso",
    requestScreenTimeAccess: "Richiedi accesso a Tempo di utilizzo",
    openUsageAccess: "Apri accesso ai dati di utilizzo",
    openingUsageAccess: "Apertura accesso utilizzo…",
    legalSection: "Legale",
    privacyPolicyRow: "Informativa sulla privacy",
    termsRow: "Termini",
    resetSection: "Reimposta",
    deletingSavedData: "Eliminazione dati salvati",
    deleteSavedData: "Elimina dati salvati e reimposta ID dispositivo",
    resetSuccess:
      "Eliminati {count} record salvati. È stato creato un nuovo ID dispositivo anonimo.",
    resetFailed: "Reimpostazione non riuscita.",
    footerNoAccount: "Nessun account richiesto.",
    languageRow: "Lingua",
    purchasesSection: "Acquisti",
  },
  language: {
    eyebrow: "Lingua app",
    title: "Lingue",
    subtitle:
      "Screen0 segue la lingua preferita dell'app configurata nel sistema. Cambiala dalle Impostazioni iPhone quando vuoi.",
    subtitleAndroid:
      "Screen0 segue la lingua preferita dell'app configurata nel sistema. Cambiala dalle Impostazioni Android quando vuoi.",
    subtitleAndroidLegacy:
      "Su questa versione di Android, Screen0 segue la lingua del dispositivo. Cambiala in Impostazioni → Lingue e immissione.",
    activeLanguageLabel: "Lingua attiva",
    systemLanguageLabel: "Preferenza sistema",
    fallbackNote:
      "La lingua di sistema selezionata non è ancora supportata da Screen0, quindi l'app usa l'inglese come fallback.",
    unavailableSystemValue: "Non disponibile",
    openSettingsTitle: "Apri Impostazioni iPhone",
    openSettingsTitleAndroid: "Apri impostazioni lingua app",
    openSettingsTitleAndroidLegacy: "Apri Impostazioni Android",
    openSettingsSubtitle:
      "Vai alla pagina di sistema di Screen0 per cambiare la lingua dell'app.",
    openSettingsSubtitleAndroid:
      "Vai alla pagina lingua di Screen0 per cambiare la lingua dell'app.",
    openSettingsSubtitleAndroidLegacy:
      "Si apre la scheda dell'app. Cambia la lingua del dispositivo in Lingue — la lingua per app richiede Android 13 o successivo.",
    openingSettingsLabel: "Apro Impostazioni",
    closeLabel: "Chiudi",
    footerReady:
      "Quando torni nell'app, Screen0 sincronizza automaticamente la lingua aggiornata.",
    footerReadyAndroid:
      "Quando torni nell'app, Screen0 sincronizza automaticamente la lingua aggiornata.",
    footerReadyAndroidLegacy:
      "Quando torni nell'app, Screen0 si sincronizza con la lingua del dispositivo.",
    footerOpening: "Apro la pagina di sistema...",
    openSettingsUnavailableTitle: "Impostazioni non disponibili",
    openSettingsUnavailableDescription:
      "Non riesco ad aprire le Impostazioni dell'app da questo ambiente.",
  },
  permission: {
    gateTitle: "Autorizzazione necessaria per il report di oggi",
    gateBody:
      "Screen0 funziona senza account, ma iOS richiede l'autorizzazione Tempo di utilizzo prima di mostrare l'uso delle app.",
    gateBodyAndroid:
      "Screen0 ha bisogno dell'accesso ai dati di utilizzo per mostrare le app di oggi. Android non mostra un popup di autorizzazione: apri Impostazioni, trova Screen0 in Accesso ai dati di utilizzo e attivalo.",
    requestingAccess: "Richiesta accesso in corso",
    requestScreenTimeAccess: "Richiedi accesso a Tempo di utilizzo",
    openUsageAccess: "Apri accesso ai dati di utilizzo",
    openingUsageAccess: "Apertura accesso utilizzo…",
    entitlementMissing:
      "Questa build non include l'entitlement Family Controls o il profilo di provisioning corrispondente. I dati Tempo di utilizzo non possono essere raccolti finché la firma non è corretta.",
  },
  calendar: {
    chooseDate: "Scegli data",
    previousMonth: "Mese precedente",
    nextMonth: "Mese successivo",
  },
  query: {
    loadingDefault: "Caricamento…",
    errorTitle: "Qualcosa è andato storto",
  },
  app: {
    syncError:
      "Impossibile salvare l'utilizzo di oggi. Screen0 riproverà quando riapri l'app.",
    reinstallRulesPurged:
      "Le regole di blocco sono state reimpostate: le selezioni app non sopravvivono alla reinstallazione. Configurale di nuovo in Regole.",
  },
  format: {
    activationSingular: "Attivazione",
    activationPlural: "Attivazioni",
    durationMinutes: "{minutes}m",
    durationHoursOnly: "{hours} ore",
    durationOneHour: "1 ora",
    durationHoursMinutes: "{hours}h {minutes}m",
    allDay: "Tutto il giorno",
    timeBandMorning: "mattina",
    timeBandAfternoon: "pomeriggio",
    timeBandEvening: "sera",
    timeBandNight: "notte",
  },
  appDetail: {
    dailyAverage: "Media giornaliera",
    dailyAverageInfoAria: "Informazioni sulla media giornaliera di {metric}",
    dailyAverageInfoBodyTime1:
      "Media oraria del tempo di utilizzo di questa app negli ultimi ~12 mesi.",
    dailyAverageInfoBodyTime2:
      "Ogni ora è la media su tutti i giorni con dati del dispositivo in quel periodo. I giorni senza utilizzo di questa app contano come zero. I giorni precedenti all'inizio della raccolta dati sono esclusi.",
    dailyAverageInfoBodyOpens1:
      "Media oraria delle attivazioni di questa app negli ultimi ~12 mesi.",
    dailyAverageInfoBodyOpens2:
      "Ogni ora è la media su tutti i giorni con dati del dispositivo in quel periodo. I giorni senza utilizzo di questa app contano come zero. I giorni precedenti all'inizio della raccolta dati sono esclusi.",
    panelCalendar: "Calendario",
    panelChart: "Grafico",
    noUsage: "Nessun utilizzo",
  },
  ring: {
    screenTime: "Tempo di utilizzo",
    activations: "Attivazioni",
    percentOfTotal: "{percent}% del totale",
    notTracked: "Non tracciato",
    screenActivationsByApp: "Attivazioni schermo per app",
    screenTimeByApp: "Tempo di utilizzo per app",
    showScreenTime: "Mostra tempo di utilizzo",
    showScreenActivations: "Mostra attivazioni schermo",
    chartDescriptionDay:
      "Tempo di utilizzo e attivazioni orarie per il giorno selezionato",
    chartDescriptionWeek:
      "Tempo di utilizzo e attivazioni giornaliere per la settimana selezionata",
    chartDescriptionMonth:
      "Tempo di utilizzo e attivazioni giornaliere per il mese selezionato",
  },
  smartBlock: {
    goalDoom: "Riduci il doom-scroll",
    goalCompulsivity: "Riduci la compulsività",
    actionLabel: "Blocca completamente {range}",
    reasonDoomShare:
      "Il {sharePct}% del tuo utilizzo di {name} avviene tra le {range}. Bloccare quella finestra colpisce il periodo a più alto rischio.",
    reasonDoomCluster:
      "L'utilizzo di {name} tende a concentrarsi in questa parte della giornata. Bloccare {range} colpisce il periodo a più alto rischio.",
    reasonCompulsivityOpens: "Apri {name} più spesso tra le {range}.",
    reasonCompulsivityTime: "La maggior parte del tempo su {name} cade tra le {range}.",
    reasonCompulsivityShareSuffix:
      "Un blocco completo in quella finestra interrompe il ciclo dell'abitudine.",
    reasonCompulsivityRepeat:
      "{name} riceve ripetuti sblocchi in questa parte della giornata. Un blocco completo tra le {range} interrompe il ciclo dell'abitudine.",
    reactivateHint: "La regola esiste ma è disattivata — tocca per riattivarla",
  },
  permissionStatus: {
    granted: "Concesso",
    denied: "Negato",
    unavailable: "Non disponibile",
    notDetermined: "Non determinato",
  },
  onboarding: {
    progressLabel: "Avanzamento onboarding",
    continue: "Continua",
    working: "Attendere…",
    goToToday: "Vai a Oggi",
    narrative4Cta: "Per cosa vuoi quel tempo?",
    narrative1ImageAlt: "Zero con lo schermo in mano senza rendersene conto",
    narrative2ImageAlt: "Zero tirato da fili verso uno schermo luminoso",
    narrative3ImageAlt: "Zero a tavola senza telefono",
    narrative4ImageAlt: "Zero che fa il primo passo su un sentiero senza telefono",
    narrative1: [
      "Hai mai notato come ti ritrovi con uno schermo in mano senza nemmeno rendertene conto? Bastano **15 secondi** di attesa e già cerchi lo schermo.",
      "Abbiamo imparato a **non lasciare vuoto** e a contemplare nemmeno un istante.",
      "Ping, scroll, tab: è facile sentirsi confusi e **divisi**.",
    ],
    narrative2: [
      "Non è mancanza di **forza e di volontà**. Le app sono progettate e ingegnerizzate per **tenerti lì**: ogni scroll rende più difficile **staccarti**.",
      "Screen0 ti aiuta a **creare distanza**, non a cercare di essere **perfetti**.",
    ],
    narrative3: [
      "Meno schermo non significa meno vita, vuol dire più **spazio** per il lavoro, le persone, il sonno.",
      "Sperimenta nuovamente un pasto senza telefono, una sera senza scrolling: sembrano piccoli i confini, ma fanno una **grande differenza**.",
    ],
    narrative4: [
      "**Hai già fatto il primo passo.**",
      "Una camminata senza telefono. Una mattina senza feed. I cambiamenti **partono da qui**.",
    ],
    benefitsHeadline: "Ecco come **Screen0** può aiutarti nella prossima settimana",
    benefits: [
      {
        title: "Concentrazione in pochi minuti",
        subtitle: "Configurazione facile e personalizzabile",
      },
      {
        title: "Recupera oltre 2 ore al giorno",
        subtitle: "Meno scroll. Più tempo per ciò che conta.",
      },
      {
        title: "Fai di più",
        subtitle: "Fino al 50% più produttivo al lavoro con Screen0",
      },
      {
        title: "Dormi meglio",
        subtitle:
          "Smetti di scrollare a tarda notte con un programma serale che funziona davvero",
      },
    ],
    trialHeadline: "Prova Premium **gratis.** Nessuna sorpresa.",
    trialRows: [
      {
        dayLabel: "TODAY",
        title: "Nessun addebito oggi",
        subtitle:
          "Solo accesso alle funzioni Premium come Regole e Smart Blocks",
      },
      {
        dayLabel: "DAY 5",
        title: "Promemoria prima della fine della prova",
        subtitle: "Ti avviseremo 2 giorni prima della fine della prova gratuita",
      },
      {
        dayLabel: "DAY 7",
        title: "Annulla quando vuoi",
        subtitle: "Gli abbonamenti possono essere annullati in qualsiasi momento",
      },
    ],
    primaryGoalQuestion: "Qual è la cosa più importante per cui vuoi il tuo tempo?",
    timeLostQuestion: "Dove perdi più tempo?",
    timeLostSubtitle: "Hai scelto {goal} — dove va via il tempo?",
    difficultyQuestion: "Quanto è difficile resistere?",
    goals: {
      work: "Lavoro",
      study: "Studio",
      sleep: "Sonno",
      family: "Famiglia",
      hobby: "Hobby",
      exercise: "Esercizio",
      balance: "Equilibrio",
      wellness: "Benessere",
      other: "Altro",
    },
    timeLostOptions: {
      social: "Social",
      news: "Notizie",
      gaming: "Gaming",
      streaming: "Streaming",
      work: "Lavoro",
      shopping: "Shopping",
      messages: "Messaggi",
      browsing: "Navigazione",
      other: "Altro",
    },
    difficultyEmojis: ["😌", "🙂", "😐", "😣", "😫"],
    difficultyLevels: [
      "Molto facile",
      "Facile",
      "A volte difficile",
      "Difficile",
      "Molto difficile",
    ],
    insight8ImageAlt: "Scena serale con telefono messo da parte",
    insight8Headline: "**Questo conta.**",
    insight8Body:
      "Proteggere il tuo tempo è uno dei confini che funzionano davvero. Piccoli limiti portano a cambiamenti reali.",
    insight8SleepHeadline: "**Questo conta.**",
    insight8SleepBody:
      "Dopo le 19 il telefono può aspettare. **Staccare la sera** è uno dei confini che funzionano.",
    insight9ImageAlt: "Illustrazione su attenzione e schermi",
    insight9SocialHeadline: "Sei contro una **macchina**.",
    insight9SocialBody: "Il feed non ha un fine — è **progettato** così.",
    insight9OtherHeadline: "Ogni notifica **spezza** il focus.",
    insight9OtherBody: "Riprendersi può richiedere **20 minuti**.",
    notificationsHeadline:
      "Ti invieremo un promemoria **2 giorni** prima della fine della prova",
    notificationsBody:
      "Consenti le notifiche così possiamo avvisarti prima dell'addebito",
    notificationsAllow: "CONSENTI NOTIFICHE",
    notificationsMaybeLater: "FORSE DOPO",
    notificationsDeniedWarning:
      "Le notifiche sono disattivate. Attivale nelle Impostazioni così possiamo avvisarti prima della fine della prova.",
    setupImageAlt: "Illustrazione permessi",
    setupTitle: "Un permesso rapido",
    setupBody:
      "Screen0 ha bisogno dell'accesso di sistema per mostrare il tuo report personale. Nessun account richiesto.",
    setupNativeHint: "Puoi cambiarlo in qualsiasi momento nelle Impostazioni.",
    setupWebHint:
      "Sul web i report richiedono l'app mobile. Puoi continuare e configurarlo dopo sul telefono.",
    overlayImageAlt: "Illustrazione permesso mostra sopra altre app",
    overlayTitle: "Consenti la schermata di blocco",
    overlayBody:
      "Screen0 ha bisogno di “Mostra sopra altre app” per far comparire la schermata di blocco quando apri un’app bloccata. Senza questo permesso le regole non possono proteggerti.",
    overlayNativeHint:
      "Si apriranno le impostazioni di Android. Abilita Screen0, poi torna all’app.",
    overlayCta: "APRI IMPOSTAZIONI",
    overlayNotNow: "NON ORA",
    vpnImageAlt: "Illustrazione del filtro siti sul dispositivo",
    vpnTitle: "Installa il filtro per i siti",
    vpnBody:
      "Per bloccare i siti in Safari e negli altri browser, Screen0 deve aggiungere un profilo di filtro locale.",
    vpnBodyAndroid:
      "Per bloccare i siti in Chrome e negli altri browser, Screen0 deve aggiungere un profilo di filtro locale.",
    vpnPrivacyTitle: "Impegno per la privacy",
    vpnPrivacyBody:
      "Aggiunge un filtro sul dispositivo che blocca solo i siti che scegli tu. Tutto il filtraggio avviene sul telefono — i tuoi dati non lasciano mai il dispositivo.",
    vpnWebHint:
      "Sul web il blocco dei siti richiede l'app mobile. Puoi continuare e configurarlo dopo sul telefono.",
    vpnInstall: "INSTALLA PROFILO",
    vpnNotNow: "NON ORA",
    vpnErrorTitle: "Impossibile installare il filtro",
    vpnErrorHint: "Il profilo VPN non è stato aggiunto. Puoi saltare per ora e riprovare più tardi.",
    trackingImageAlt: "Illustrazione di analisi anonime",
    trackingTitle: "Sostieni una Screen0 migliore",
    trackingBody:
      "Consentire il tracciamento anonimo ci aiuta a capire cosa funziona e a migliorare l'app per tutti.",
    trackingPrivacyTitle: "Impegno per la privacy",
    trackingPrivacyBody: "Nessuna pubblicità, nessun dato personale, nessuna vendita dei tuoi dati. Mai.",
    trackingAllow: "CONTINUA",
    trackingNotNow: "NON ORA",
    welcomeImageAlt: "Illustrazione di benvenuto",
    welcomeTitle: "Sei pronto.",
    welcomeRecap:
      "Vuoi più tempo per **{goal}**. Screen0 ti aiuterà a proteggerlo — a partire da oggi.",
    welcomeRecapFallback:
      "Screen0 ti aiuterà a proteggere il tuo tempo — a partire da oggi.",
    paywall: {
      headline: "Recupera oltre 2 ore al giorno con Screen0 Premium",
      timeline: [
        {
          title: "Inizia il tuo percorso di focus",
          description:
            "Sei sulla buona strada per trasformare l'intenzione in un'abitudine quotidiana di concentrazione.",
        },
        {
          title: "Oggi: riprendi il controllo",
          description:
            "Sblocca strumenti potenti come **Regole** e **Smart Blocks**. Imposta il tuo primo limite e proteggi il tuo tempo oggi.",
        },
        {
          title: "Giorno 5: senti la differenza",
          description:
            "A questo punto noterai più calma, chiarezza e controllo sul tuo tempo. Ti avviseremo prima della fine della prova — nessuna sorpresa.",
        },
        {
          title: "Giorno 7: continua così",
          description:
            "Continua il tuo percorso di focus con Premium. Annulla in qualsiasi momento se non fa per te.",
        },
      ],
      timelineTrialDescriptionWithTrial:
        "Inizia la prova gratuita di {trialDays} giorni e sblocca strumenti potenti come **Regole** e **Smart Blocks**. Imposta il tuo primo limite e proteggi il tuo tempo oggi.",
      timelineTrialDescriptionNoTrial:
        "Sblocca strumenti potenti come **Regole** e **Smart Blocks**. Imposta il tuo primo limite e proteggi il tuo tempo oggi.",
      yearlyBadgeWithTrial: "{trialDays} giorni di prova gratuita, poi {price} /anno",
      yearlyBadgeNoTrial: "{price} /anno",
      yearlyTitle: "Annuale",
      yearlySubtext: "(Solo {monthlyPrice} /mese — meno di un caffè)",
      lifetimeTitle: "A vita",
      lifetimeSubtext: "Acquisto una tantum. Tuo per sempre.",
      ctaYearly: "INIZIA LA PROVA GRATUITA",
      ctaLifetime: "OTTIENI ACCESSO A VITA",
      footerRenewal: "Si rinnova automaticamente fino all'annullamento. Annulla quando vuoi.",
      footerLifetime: "Acquisto una tantum. Nessun abbonamento.",
      termsLink: "Termini",
      privacyLink: "Privacy",
      purchase: {
        processing: "Elaborazione…",
        genericError: "Qualcosa è andato storto. Riprova.",
        notEntitled: "Acquisto completato, ma Premium non è ancora attivo. Riprova.",
        webUnavailable: "Gli acquisti sono disponibili solo nell'app Screen0.",
        configError: "Gli acquisti non sono disponibili al momento. Riprova più tardi.",
        offeringsError: "Impossibile caricare i prezzi. Controlla la connessione e riprova.",
        retry: "Riprova",
        restorePurchases: "Ripristina acquisti",
        restoreProcessing: "Ripristino…",
        restoreSuccess: "Acquisti ripristinati. Premium è attivo.",
        restoreNothingFound: "Nessun acquisto da ripristinare.",
        restoreNothingFoundApple: "Nessun acquisto trovato per questo ID Apple.",
        restoreNothingFoundGoogle: "Nessun acquisto trovato per questo account Google Play.",
        restoreError: "Impossibile ripristinare gli acquisti. Riprova.",
      },
    },
  },
  categories: {
    books: "Libri",
    business: "Affari",
    catalogs: "Cataloghi",
    developerTools: "Strumenti per sviluppatori",
    education: "Istruzione",
    entertainment: "Svago",
    finance: "Finanza",
    foodAndDrink: "Cibo e bevande",
    games: "Giochi",
    graphicsAndDesign: "Creatività",
    healthAndFitness: "Salute e benessere",
    kids: "Bambini",
    lifestyle: "Stile di vita",
    medical: "Medicina",
    miscellaneous: "Varie",
    music: "Musica",
    navigation: "Navigazione",
    news: "Informazione e lettura",
    newsstand: "Edicola",
    photoAndVideo: "Foto e video",
    productivity: "Produttività e finanza",
    reference: "Riferimenti",
    shopping: "Acquisti e cibo",
    socialNetworking: "Social",
    sports: "Sport",
    stickers: "Adesivi",
    travel: "Viaggi",
    system: "Sistema",
    utilities: "Utility",
    weather: "Meteo",
    uncategorized: "Altro",
    other: "Altro",
    website: "Sito web",
  },
  websiteCategories: {
    modalTitle: "Categorie di siti",
    expandInfoAria: "Mostra dettagli per {name}",
    collapseInfoAria: "Nascondi dettagli per {name}",
    toggleCategoryAria: "Attiva o disattiva {name}",
    domainsHeading: "Domini inclusi",
    removeCategoryAria: "Rimuovi {name}",
    browseCategoriesButton: "Categorie",
    browseCategoriesAria: "Apri le categorie di siti",
    addWebsiteAria: "Aggiungi sito web",
    social: {
      name: "Social",
      description: "Social network, forum e piattaforme di community.",
    },
    meta: {
      name: "Meta",
      description: "Facebook, Instagram, WhatsApp e Messenger.",
    },
    messaging: {
      name: "Messaggistica",
      description: "App di chat e servizi di messaggistica diretta.",
    },
    news: {
      name: "Notizie",
      description: "Siti di notizie, editori e testate informative.",
    },
    dating: {
      name: "Incontri",
      description: "App e siti di incontri.",
    },
  },
});

export default IT_TRANSLATIONS;
